import React, { createContext, useState, useEffect } from 'react';
import { Theme } from 'baseui/theme';
import { THEMES, TYPOGRAPHY_SIZE } from './themes';
import { renderer } from '../swalConfigured';

type ThemeContextType = {
  theme: Theme,
  updateTheme: (arg?: any) => void,
  updateTypography: (arg?: any) => void,
  isDefault: boolean,
  basicTypography: boolean
}
const ThemeSwitchContext = createContext({
  theme: {},
  updateTheme: () => {},
  updateTypography: () => {},
  isDefault: true,
  basicTypography: true
} as ThemeContextType)

const getThemeFromStorage = () => {
  const theme = localStorage.getItem('theme') || ''
  if(THEMES[theme])
    return theme
  else
    return 'LIGHT'
}
const setThemeForStorage = (themeName: string) => {
    localStorage.setItem('theme', themeName);
};

export function ThemeSwitchProvider({ children, render }: any) {
    const [theme, setTheme] = useState(getThemeFromStorage());
    const [typography, setTypography] = useState(TYPOGRAPHY_SIZE.normal);
    useEffect(() => {
        document.body.style.backgroundColor = THEMES[theme].colors.primaryB;
        document.body.dataset.theme = theme.toLowerCase()
        setThemeForStorage(theme);
        renderer(undefined, THEMES[theme], theme === 'LIGHT');
    }, [theme]);

    useEffect(() => {
        document.documentElement.style.fontSize = typography;
    }, [typography]);
    return (
        <ThemeSwitchContext.Provider
            value={{
                theme: THEMES[theme],
                updateTheme: setTheme,
                updateTypography: setTypography,
                isDefault: theme === 'LIGHT',
                basicTypography: typography === TYPOGRAPHY_SIZE.normal
            }}
        >
            {render(THEMES[theme])}
        </ThemeSwitchContext.Provider>
    );
}
export const context = ThemeSwitchContext;